import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-verify-employee-detail',
  templateUrl: './view-verify-employee-detail.component.html',
  styleUrls: ['./view-verify-employee-detail.component.css']
})
export class ViewVerifyEmployeeDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
